import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Intensité des animations (high | low | off) — persistée par l'utilisateur
try {
  document.documentElement.dataset.anim = localStorage.getItem("animLevel") || "high";
} catch { document.documentElement.dataset.anim = "high"; }

// Marque active (amen | mg) → thème couleur global, posé avant le 1er rendu
try {
  document.documentElement.dataset.brand = localStorage.getItem("brand") || "amen";
} catch { document.documentElement.dataset.brand = "amen"; }

const app = (
  <React.StrictMode>
    <App />
    <ToastContainer
      position="top-right"
      autoClose={2600}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnHover
      theme="colored"
    />
  </React.StrictMode>
);

// Hydratation si la page a été pré-rendue (react-snap), sinon rendu classique.
const rootEl = document.getElementById('root');
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
